export function buildFormData<T extends Record<string, any>>(data: T): FormData {
	const formData = new FormData();

	Object.keys(data).forEach((key: string) => {
		const value = data[key as keyof T];

		if (value === undefined) return;

		if (Array.isArray(value)) {
			value.forEach((item: unknown) => {
				formData.appendValueWithTypeCheck(key, item);
			});
			return;
		}

		formData.appendValueWithTypeCheck(key, value);
	});

	return formData;
}
